<script lang="ts">
import { defineComponent, reactive } from 'vue'
import PrDocumentCardBanners from '@/components/banner/PrDocumentCardBanners.vue'
import SignUpCta from '@/components/cta/SignUpCta.vue'
import RankingWeeklyForAside from '@/components/contents/RankingWeeklyForAside.vue'
import stateInitializer from '@/models/stateInitializer'
import { useUserStore } from '@/stores/user'

export default defineComponent({
  name: 'ThemeStoriesAsideSecondary',

  components: {
    PrDocumentCardBanners,
    SignUpCta,
    RankingWeeklyForAside,
  },

  setup() {
    // store
    const userStore = useUserStore()

    interface State {
      prDocuments: SolutionContentItem[],
      themeId: Maybe<number>,
    }

    const state: State = reactive({
      prDocuments: [],
      themeId: undefined,
    })

    stateInitializer(state, 'asideSecondary')

    return {
      // store
      userStore,

      // data
      state,
    }
  },
})
</script>

<template>
  <section class="section">
    <PrDocumentCardBanners
      v-if="state.prDocuments.length"
      :items="state.prDocuments" />

    <SignUpCta v-if="!userStore.context.isSignedIn" />

    <RankingWeeklyForAside
      v-if="state.themeId"
      :theme-id="state.themeId" />
  </section>
</template>
